export enum PaymentType {
  PAYMENT = 'Payment',
  QUICK_PAYMENT = 'Quick Payment'
}
